import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Button, Col, Row } from 'react-bootstrap';

import PagoForm from './pagos/PagoForm';
import PagosSummary from './pagos/PagosSummary';
import DocumentoManager from './pagos/DocumentoManager';
import PagosTotalesCalculator from '../../support/pagos/PagosTotalesCalculator';
import PagosImpuestosCalculator from '../../support/pagos/PagosImpuestosCalculator';

const ComplementoPagos = (props) => {
  const date = !!props.FechaPago ? moment(props.FechaPago, 'YYYY-MM-DDTHH:mm:ss') : undefined;

  const [data, setData] = useState({
    FechaPago: !!date ? date.toDate() : new Date(),
    HoraPago: !!date ? date.format('HH:mm') : '12:00',
  });

  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (!!props.data && props.data.Complemento?.Pagos?.Pago?.length === 1) {
      handleOnEdit(0, true);
    }
  }, []); // eslint-disable-line

  const handleOnEdit = (index, editing = undefined) => {
    const originalPagos = (!!props.data && props.data.Complemento?.Pagos?.Pago) || [];

    const data = originalPagos[index] || {};

    const date = !!data.FechaPago ? moment(data.FechaPago, 'YYYY-MM-DDTHH:mm:ss') : undefined;

    handleOnDelete(index, true);

    setData({
      editing,
      ...data,
      FechaPago: !!date ? date.toDate() : undefined,
      HoraPago: !!date ? date.format('HH:mm') : '12:00',
    });

    setIsValid(true);
  };

  const handleOnDelete = (index, showPagosForm = false) => {
    const originalPagos = (!!props.data && props.data.Complemento?.Pagos?.Pago) || [];

    const data = originalPagos.filter((item, _index) => {
      return index !== _index;
    });

    const Pagos = {
      Pago: [...data],
    };

    const complemento = { Pagos };

    props.onChange(complemento, showPagosForm);

    clearState();
  };

  const handleOnChange = (value) => {
    setData({
      ...data,
      ...value,
    });
  };

  const handleOnPagoChange = (value, isValid) => {
    setIsValid(isValid);

    handleOnChange(value);
  };

  const handleOnAdd = (event) => {
    const { DoctoRelacionado = {} } = data;
    const pago = {
      FechaPago: data.FechaPago,
      HoraPago: data.HoraPago,
      FormaDePagoP: data.FormaDePagoP,
      MonedaP: data.MonedaP,
      TipoCambioP: data.TipoCambioP,
      Monto: data.Monto,
      NumOperacion: data.NumOperacion,
      RfcEmisorCtaOrd: undefined,
      NomBancoOrdExt: undefined,
      CtaOrdenante: data.CtaOrdenante,
      RfcEmisorCtaBen: undefined,
      CtaBeneficiario: data.CtaBeneficiario,
      TipoCadPago: undefined,
      CertPago: undefined,
      CadPago: undefined,
      SelloPago: undefined,
      DoctoRelacionado: DoctoRelacionado,
    };

    const originalPagos = props.data.Complemento?.Pagos?.Pago || [];

    let tmpPago = originalPagos.concat(pago);

    tmpPago = new PagosImpuestosCalculator(tmpPago).apply().get();

    let totales = new PagosTotalesCalculator(tmpPago).apply();

    const Pagos = {
      Version: '2.0',
      Pago: tmpPago,
      Totales: totales,
    };

    const complemento = { Pagos };

    props.onChange(complemento, false);

    clearState();
  };

  const handleOnNewPagoAddRequest = () => {
    props.onChange({}, true);
  };

  const clearState = () => {
    setData({});
  };

  const {
    data: comprobante,
    data: { Complemento = {} },
    showForm = true,
  } = props;

  const isValidForm = isValid && !!data.DoctoRelacionado && data.DoctoRelacionado.length > 0;

  return (
    <div className="section">
      {!!showForm && (
        <>
          <DocumentoManager
            editing={data.editing}
            data={data}
            comprobante={comprobante}
            onChange={handleOnChange}
          />

          <PagoForm
            data={data}
            onChange={handleOnPagoChange}
          />

          {!!isValidForm && (
            <Row className="py-3">
              <Col>
                Ya registraste al menos un comprobante, para terminar agrega el pago para completar el complemento de
                pagos.
              </Col>
            </Row>
          )}

          <Row>
            <Col>
              <Button
                variant="secondary"
                disabled={!isValidForm}
                onClick={handleOnAdd}
              >
                Agregar pago
              </Button>
            </Col>
          </Row>
        </>
      )}

      {!showForm && (
        <div className="mt-2 pb-3">
          <p>¿Quieres agregar un nuevo pago?</p>
          <Button
            variant="secondary"
            onClick={handleOnNewPagoAddRequest}
          >
            Agregar pago
          </Button>
        </div>
      )}

      <PagosSummary
        data={(!!Complemento && Complemento.Pagos) || {}}
        onEdit={handleOnEdit}
        onDelete={handleOnDelete}
      />
    </div>
  );
};

export default ComplementoPagos;
